module.exports = __webpack_public_path__ + "static/media/image-gallery-11.48f16643.jpg";